import {
  generateApiKeyService,
  saveWebhookService,
  getCustomersService,
  getExternalApiDashboardInformationService,
  getApiCredentialsService,
  getAllYieldOfferingProfilesService,
  getTerminalSettlementsService,
  getYieldProfileByIdService,
  createYieldProfileService,
  getYieldProfileCustomersByIdService,
  getTerminalSettlementBatchDetailsService,
  cancelTerminalTransferBatchService,
  cancelTreasuryDepositBatchService,
  cancelTreasuryWithdrawalBatchService,
  getTreasuryTransactionsService,
  getTerminalTransactionsService,
  getTreasurySettlementsService,
  getTreasurySettlementBatchDetailsService,
  getCustomerDetailsService,
  getCustomerDetailsTransactions,
  settleCustomerTransferService,
  settleCustomerDepositService,
  editYieldProfileService,
  getPortfoliosService,
  settleCustomerAssetTransferService,
  getCustomerDetailsTransactionsService,
  getCustomerVirtualAccountService,
  getCustomerDetailsTransactionsByIDService,
  whitelistIPsService,
  deleteWhiteListedIPService
} from '@/services/externalApiService'

// mutation types
const set_apiKeyInformation = 'set_apiKeyInformation'
const set_webhookInformation = 'set_webhookInformation'
const set_customers = 'set_customers'
const set_editYieldProfile = 'set_editYieldProfile'
const set_externalApiDashboard = 'set_externalApiDashboard'
const set_apiCredentials = 'set_apiCredentials'
const set_yieldOfferingProfilesInformation =
  'set_yieldOfferingProfilesInformation'
const set_terminalSettlementInformation = 'set_terminalSettlementInformation'
const set_treasurySettlementInformation = 'set_treasurySettlementInformation'
const set_yieldProfileDetails = 'set_yieldProfileDetails'
const set_createYieldProfileInformation = 'set_createYieldProfileInformation'
const set_yieldProfileCustomers = 'set_yieldProfileCustomers'
const set_batchDetails = 'set_batchDetails'
const set_activeComponent = 'set_activeComponent'
const set_cancelTerminalTransferBatchInfo =
  'set_cancelTerminalTransferBatchInfo'
const set_cancelTreasuryDepositBatchInfo = 'set_cancelTreasuryDepositBatchInfo'
const set_cancelTreasuryWithdrawalBatchInfo =
  'set_cancelTreasuryWithdrawalBatchInfo'
const set_terminalTransactions = 'set_terminalTransactions'
const set_treasuryTransactions = 'set_treasuryTransactions'
const set_customerDetails = 'set_customerDetails'
const set_customerDetailsTreasuryTransactions =
  'set_customerDetailsTreasuryTransactions'
const set_customerDetailsTerminalTransactions =
  'set_customerDetailsTerminalTransactions'
const set_settledTransferDetails = 'set_settledTransferDetails'
const set_settledTransferInfo = 'set_settledTransferInfo'
const set_transferDetails = 'set_transferDetails'
const set_portfolioInformation = 'set_portfolioInformation'
const set_transferCustomerDetailsTransactions =
  'set_transferCustomerDetailsTransactions'
const set_withdrawalCustomerDetailsTransactions =
  'set_withdrawalCustomerDetailsTransactions'
const set_depositCustomerDetailsTransactions =
  'set_depositCustomerDetailsTransactions'
const set_customerVirtualAccount = 'set_customerVirtualAccount'
const set_customerTransactionDetails = 'set_customerTransactionDetails'
// state
const getDefaultState = () => {
  return {
    apiKeyInformation: {},
    webhookInformation: {},
    yieldOfferingProfilesInformation: {},
    customers: {
      items: [],
      page: {
        hasNextPage: false,
        hasPreviousPage: false,
        page: 1,
        size: 10,
        totalCount: 0
      }
    },
    customerDetails: {},
    customerDetailsTreasuryTransactions: {
      items: [],
      page: {
        page: 1,
        size: 10,
        hasNextPage: false,
        hasPreviousPage: false,
        totalCount: 0
      }
    },
    customerDetailsTerminalTransactions: {
      items: [],
      page: {
        page: 1,
        size: 10,
        hasNextPage: false,
        hasPreviousPage: false,
        totalCount: 0
      }
    },
    editYieldProfile: '',
    externalApiDashboard: {
      requestID: '',
      customerCount: 0,
      transactionCount: 0,
      settlementCount: 0,
      yieldOfferingCount: 0
    },
    apiCredentials: {
      key: '',
      token: '',
      webhook: ''
    },
    terminalSettlementInformation: {},
    yieldProfileDetails: {
      apy_rate: '',
      created_at: '',
      currency: '',
      deposit_lock_day: 0,
      description: '',
      maximum_deposit_allowed: 0,
      minimum_deposit_allowed: 0,
      name: '',
      portfolio_id: '',
      reference: '',
      updated_at: '',
      withdrawal_limit_rate: 0,
      yield_offering_id: '',
      yieldable_after_day: ''
    },
    createYieldProfileInformation: {},
    yieldProfileCustomers: {
      items: [],
      page: {
        hasNextPage: false,
        hasPreviousPage: false,
        page: 1,
        size: 10,
        totalCount: 0
      }
    },
    treasuryTransactions: {
      items: [],
      page: {
        hasNextPage: false,
        hasPreviousPage: false,
        page: 1,
        size: 10,
        totalCount: 0
      }
    },
    batchDetails: {
      items: [],
      page: {
        hasNextPage: false,
        hasPreviousPage: false,
        page: 1,
        size: 10,
        totalCount: 0
      }
    },
    treasurySettlementInformation: {
      items: [],
      page: {
        page: 1,
        size: 10,
        hasNextPage: false,
        hasPreviousPage: false,
        totalCount: 0
      }
    },
    activeComponent: 'AllCustomers',
    cancelTerminalTransferBatchInfo: '',
    cancelTreasuryDepositBatchInfo: '',
    cancelTreasuryWithdrawalBatchInfo: '',
    terminalTransactions: {
      items: [],
      page: {
        hasNextPage: false,
        hasPreviousPage: false,
        page: 1,
        size: 10,
        totalCount: 0
      }
    },
    settledTransferInfo: {},
    settledTransferDetails: {
      recipientInformation: {},
      transferDetails: {}
    },
    portfolioInformation: [],
    transferCustomerDetailsTransactions: {
      items: [],
      page: {
        page: 1,
        size: 10,
        hasNextPage: false,
        hasPreviousPage: false,
        totalCount: 0
      }
    },
    withdrawalCustomerDetailsTransactions: {
      items: [],
      page: {
        page: 1,
        size: 10,
        hasNextPage: false,
        hasPreviousPage: false,
        totalCount: 0
      }
    },
    depositCustomerDetailsTransactions: {
      items: [],
      page: {
        page: 1,
        size: 10,
        hasNextPage: false,
        hasPreviousPage: false,
        totalCount: 0
      }
    },
    customerVirtualAccount: {
      items: [],
      page: {
        page: 1,
        size: 10,
        hasNextPage: false,
        hasPreviousPage: false,
        totalCount: 0
      }
    },
    customerTransactionDetails: {}
  }
}
const state = getDefaultState()

// getters
const getters = {
  customers: (state) => state.customers,
  yieldOfferingProfilesInformation: (state) =>
    state.yieldOfferingProfilesInformation,
  terminalSettlementInformation: (state) => state.terminalSettlementInformation,
  apiCredentials: (state) => state.apiCredentials
}
// mutations
const mutations = {
  [set_apiKeyInformation] (state, data) {
    state.apiKeyInformation = data
  },
  [set_webhookInformation] (state, data) {
    state.webhookInformation = data
  },
  [set_customers] (state, data) {
    state.customers = data
  },
  [set_customerDetails] (state, data) {
    state.customerDetails = data
  },
  [set_customerDetailsTreasuryTransactions] (state, data) {
    state.customerDetailsTreasuryTransactions = data
  },
  [set_customerDetailsTerminalTransactions] (state, data) {
    state.customerDetailsTerminalTransactions = data
  },
  [set_editYieldProfile] (state, data) {
    state.editYieldProfile = data
  },
  [set_externalApiDashboard] (state, data) {
    state.externalApiDashboard = data
  },
  [set_apiCredentials] (state, data) {
    state.apiCredentials = data
  },
  [set_yieldOfferingProfilesInformation] (state, data) {
    state.yieldOfferingProfilesInformation = data
  },
  [set_terminalSettlementInformation] (state, data) {
    state.terminalSettlementInformation = data
  },
  [set_treasurySettlementInformation] (state, data) {
    state.treasurySettlementInformation = data
  },
  [set_yieldProfileDetails] (state, data) {
    state.yieldProfileDetails = data
  },
  [set_createYieldProfileInformation] (state, data) {
    state.createYieldProfileInformation = data
  },
  [set_yieldProfileCustomers] (state, data) {
    state.yieldProfileCustomers = data
  },
  [set_batchDetails] (state, data) {
    state.batchDetails = data
  },
  [set_activeComponent] (state, data) {
    state.activeComponent = data
  },
  [set_cancelTerminalTransferBatchInfo] (state, data) {
    state.cancelTerminalTransferBatchInfo = data
  },
  [set_cancelTreasuryDepositBatchInfo] (state, data) {
    state.cancelTreasuryDepositBatchInfo = data
  },
  [set_cancelTreasuryWithdrawalBatchInfo] (state, data) {
    state.cancelTreasuryWithdrawalBatchInfo = data
  },
  [set_treasuryTransactions] (state, data) {
    state.treasuryTransactions = data
  },
  [set_terminalTransactions] (state, data) {
    state.terminalTransactions = data
  },
  [set_settledTransferDetails] (state, data) {
    state.settledTransferDetails = data
  },
  [set_settledTransferInfo] (state, data) {
    state.settledTransferInfo = data
  },
  [set_transferDetails] (state, data) {
    state.settledTransferDetails.transferDetails = data
  },
  [set_portfolioInformation] (state, data) {
    state.portfolioInformation = data
  },
  [set_transferCustomerDetailsTransactions] (state, data) {
    state.transferCustomerDetailsTransactions = data
  },
  [set_withdrawalCustomerDetailsTransactions] (state, data) {
    state.withdrawalCustomerDetailsTransactions = data
  },
  [set_depositCustomerDetailsTransactions] (state, data) {
    state.depositCustomerDetailsTransactions = data
  },
  [set_customerVirtualAccount] (state, data) {
    state.customerVirtualAccount = data
  },
  [set_customerTransactionDetails] (state, data) {
    state.customerTransactionDetails = data
  },
  resetState (state) {
    Object.assign(state, getDefaultState())
  }
}

// actions
const actions = {
  resetExternalApiState ({ commit }) {
    commit('resetState')
  },
  generateApiKey: ({ commit }, payload) => {
    return generateApiKeyService(payload).then((response) => {
      commit('set_apiKeyInformation', response.data.data)
    })
  },
  saveWebhook: ({ commit }, payload) => {
    return saveWebhookService(payload).then((response) => {
      commit('set_webhookInformation', response.data.data)
    })
  },
  getCustomers: ({ commit }, payload) => {
    return getCustomersService(payload).then((response) => {
      commit('set_customers', response.data.data)
    })
  },
  getCustomerDetails: ({ commit }, id) => {
    return getCustomerDetailsService(id).then((response) => {
      commit('set_customerDetails', response.data.data)
    })
  },
  getCustomerDetailsTerminalTransactions: ({ commit }, payload) => {
    return getCustomerDetailsTransactions(payload).then((response) => {
      commit('set_customerDetailsTerminalTransactions', response.data.data)
    })
  },
  getCustomerDetailsTreasuryTransactions: ({ commit }, payload) => {
    return getCustomerDetailsTransactions(payload).then((response) => {
      commit('set_customerDetailsTreasuryTransactions', response.data.data)
    })
  },
  setEditYieldProfile: ({ commit }, payload) => {
    commit('set_editYieldProfile', payload)
  },
  getExternalApiDashboardInformation: ({ commit }) => {
    return getExternalApiDashboardInformationService().then((response) => {
      commit('set_externalApiDashboard', response.data.data)
    })
  },
  getApiCredentials: ({ commit }) => {
    return getApiCredentialsService().then((response) => {
      const data = response.data.data
      commit('set_apiCredentials', data || {})
    })
  },
  getYieldOfferingProfilesInformation: ({ commit }, payload) => {
    return getAllYieldOfferingProfilesService(payload).then((response) => {
      commit('set_yieldOfferingProfilesInformation', response.data.data)
    })
  },
  getTerminalSettlementInformation: ({ commit }, payload) => {
    return getTerminalSettlementsService(payload).then((response) => {
      commit('set_terminalSettlementInformation', response.data.data)
    })
  },
  getTerminalSettlementBatchDetails: ({ commit }) => {
    return getTerminalSettlementBatchDetailsService().then((response) => {
      commit()
    })
  },
  getTreasurySettlementInformation: ({ commit }, payload) => {
    return getTreasurySettlementsService(payload).then((response) => {
      commit('set_treasurySettlementInformation', response.data.data)
    })
  },
  getYieldProfileDetails: ({ commit }, payload) => {
    return getYieldProfileByIdService(payload).then((response) => {
      commit('set_yieldProfileDetails', response.data.data)
    })
  },
  createYieldProfile: ({ commit }, payload) => {
    return createYieldProfileService(payload).then((response) => {
      commit('set_createYieldProfileInformation', response.data.data)
    })
  },
  editYieldProfile: ({ commit }, payload) => {
    return editYieldProfileService(payload)
  },
  getYieldProfileCustomers: ({ commit }, payload) => {
    return getYieldProfileCustomersByIdService(payload).then((response) => {
      commit('set_yieldProfileCustomers', response.data.data)
    })
  },
  setBatchDetails: ({ commit }, payload) => {
    return getTerminalSettlementBatchDetailsService(payload).then(
      (response) => {
        commit('set_batchDetails', response.data.data)
      }
    )
  },
  setTreasuryBatchDetails: ({ commit }, payload) => {
    return getTreasurySettlementBatchDetailsService(payload).then(
      (response) => {
        commit('set_batchDetails', response.data.data)
      }
    )
  },
  setActiveComponent: ({ commit }, payload) => {
    commit('set_activeComponent', payload)
  },
  cancelTerminalTransferBatch: ({ commit }, payload) => {
    return cancelTerminalTransferBatchService(payload).then((response) => {
      commit('set_cancelTerminalTransferBatchInfo', response.data.data)
    })
  },
  cancelTreasuryDepositBatch: ({ commit }, payload) => {
    return cancelTreasuryDepositBatchService(payload).then((response) => {
      commit('set_cancelTreasuryDepositBatchInfo', response.data.data)
    })
  },
  cancelTreasuryWithdrawalBatch: ({ commit }, payload) => {
    return cancelTreasuryWithdrawalBatchService(payload).then((response) => {
      commit('set_cancelTreasuryWithdrawalBatchInfo', response.data.data)
    })
  },
  getTreasuryTransactions: ({ commit }, payload) => {
    return getTreasuryTransactionsService(payload).then((response) => {
      commit('set_treasuryTransactions', response.data.data)
    })
  },
  getTerminalTransactions: ({ commit }, payload) => {
    return getTerminalTransactionsService(payload).then((response) => {
      commit('set_terminalTransactions', response.data.data)
    })
  },
  settleCustomerTransfer: ({ commit }, payload) => {
    return settleCustomerTransferService(payload).then((response) => {
      commit('set_settledTransferInfo', response.data.data)
    })
  },
  settleCustomerAssetTransfer: ({ commit }, payload) => {
    return settleCustomerAssetTransferService(payload)
  },
  setTransferDetails: ({ commit }, payload) => {
    commit('set_transferDetails', payload)
  },
  settleCustomerDeposit: ({ commit }, payload) => {
    return settleCustomerDepositService(payload)
  },
  getPortfolios: ({ commit }) => {
    return getPortfoliosService().then((response) => {
      commit('set_portfolioInformation', response.data.data)
    })
  },
  getTransferCustomerDetailsTransactions: ({ commit }, payload) => {
    return getCustomerDetailsTransactionsService(payload, 'transfer').then(
      (response) => {
        commit('set_transferCustomerDetailsTransactions', response.data.data)
      }
    )
  },
  getWithdrawalCustomerDetailsTransactions: ({ commit }, payload) => {
    return getCustomerDetailsTransactionsService(payload, 'withdrawal').then(
      (response) => {
        commit('set_withdrawalCustomerDetailsTransactions', response.data.data)
      }
    )
  },
  getDepositCustomerDetailsTransactions: ({ commit }, payload) => {
    return getCustomerDetailsTransactionsService(payload, 'deposit').then(
      (response) => {
        commit('set_depositCustomerDetailsTransactions', response.data.data)
      }
    )
  },
  getCustomerVirtualAccount: ({ commit }, payload) => {
    return getCustomerVirtualAccountService(payload).then((response) => {
      commit('set_customerVirtualAccount', response.data.data)
    })
  },
  getCustomerTransactionDetailsByID: ({ commit }, payload) => {
    return getCustomerDetailsTransactionsByIDService(payload).then(
      (response) => {
        commit('set_customerTransactionDetails', response.data.data)
      }
    )
  },
  whitelistIPs: ({ commit }, payload) => {
    return whitelistIPsService(payload)
  },
  deleteWhitelistedIP: ({ commit }, payload) => {
    return deleteWhiteListedIPService(payload)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions
}
